module.exports = __webpack_public_path__ + "logo-marq.png?2adeae750fd85507af4061314c228526";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-marq.png
// module id = 323
// module chunks = 0